import { NavLink, Outlet, Navigate, useLocation } from "react-router-dom";
import { SECTION_PERMISSIONS } from "@/config/permissions";
import { usePermissions } from "@/features/auth/usePermissions";

const tabs = [
    {
        label: "Wallets",
        path: "/wallet-payments/wallets",
        permissions: SECTION_PERMISSIONS.WALLETS,
    },
    {
        label: "Transactions",
        path: "/wallet-payments/transactions",
        permissions: SECTION_PERMISSIONS.TRANSACTIONS,
    },
    {
        label: "Payments",
        path: "/wallet-payments/payments",
        permissions: SECTION_PERMISSIONS.PAYMENTS,
    },
    {
        label: "Platform Wallet",
        path: "/wallet-payments/platform",
        permissions: SECTION_PERMISSIONS.PLATFORM_WALLET,
    },
];

export const WalletPaymentsLayout = () => {
    const location = useLocation();
    const { hasAnyPermission } = usePermissions();
    const visibleTabs = tabs.filter((tab) => hasAnyPermission(tab.permissions));
    const firstVisibleTab = visibleTabs[0]?.path ?? "/wallet-payments/wallets";

    // Redirect index to wallets
    if (location.pathname === "/wallet-payments" || location.pathname === "/wallet-payments/") {
        return <Navigate to={firstVisibleTab} replace />;
    }

    // Hide sub-nav on detail pages
    const isDetailPage = /^\/wallet-payments\/(wallets|transactions|payments)\/[^/]+/.test(location.pathname);

    return (
        <div className="space-y-6">
            {!isDetailPage && (
                <div>
                    <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">Wallet & Payments</h1>
                    <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                        Manage wallets, transactions, payments, and platform earnings.
                    </p>
                    <div className="mt-4 flex gap-1 border-b border-slate-200 dark:border-slate-800">
                        {visibleTabs.map((tab) => (
                            <NavLink
                                key={tab.path}
                                to={tab.path}
                                className={({ isActive }) =>
                                    `relative px-4 py-2.5 text-sm font-medium transition-colors ${isActive
                                        ? "text-primary-600 dark:text-primary-400"
                                        : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300"
                                    }`
                                }
                            >
                                {({ isActive }) => (
                                    <>
                                        {tab.label}
                                        {isActive && (
                                            <span className="absolute bottom-0 left-0 right-0 h-0.5 rounded-full bg-primary-600 dark:bg-primary-400" />
                                        )}
                                    </>
                                )}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
            <Outlet />
        </div>
    );
};
